import { React, useState } from "react";

import {
  Grid,
  Typography,
  Paper,
  useTheme,
  Box,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Link,
  InputAdornment,
  IconButton,
  FormControl,
  Input,
  InputLabel,
} from "@mui/material";
import { Route, useNavigate, useSearchParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

//user Imports

import { NAV_ROUTES } from "../../Services/Routes/App";
import { MainRoutes } from "../../Services/Routes/App";
import {
  addvalidation,
  forgetPassword,
  resetPasswordSchema,
} from "../../Services/validation/login";
import { Formik, Form } from "formik";
import { MainUrls } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";
import { StorageKeys } from "../../Services/Storage";

import { LimospayIcon, LimospayTextIcon } from "../../Svg";

//constants

const initialValues = {
  password: "",
  confirm_password: "",
};

//styling

const useStyles = makeStyles({
  flexSetting: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
});

const ResetPassword = () => {
  // theme

  const theme = useTheme();

  const classes = useStyles();

  //navigate

  const navigate = useNavigate();

  //

  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  // States

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  // add Hanler

  const addHandler = () => {
    navigate(MainRoutes?.signup);
  };
  const addHandler2 = () => {
    navigate(NAV_ROUTES?.dashboard);
  };

  const backToLogin = () => {
    navigate(MainRoutes?.root);
  };

  const submitHandler = (values) => {
    // if (token) {
    const data = {
      user: {
        token: token,
        password: values?.password,
      },
    };

    setOpen(true);

    headersPost(MainUrls?.RESET_PASSWORD, data)
      .then((res) => {
        setOpen(false);

        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          // localStorage.setItem(StorageKeys?.token, res?.data?.token);
          navigate(MainRoutes?.root);

          //  getUrl(res?.data?.token);
        } else {
          localStorage.clear();
          navigate(MainRoutes?.root);
        }
        //  else {
        //    setAlertMsg(res?.data?.message);
        //    setAlertOpen(true);
        //    setAlertIcon("warning");
        //    localStorage.clear();
        //  }
      })
      .catch((err) => {
        const { response } = err;
        setOpen(false);
        setAlertOpen(true);

        setAlertMsg(response?.data?.message);

        setAlertIcon("warning");
        localStorage.clear();
        navigate(MainRoutes?.root);
      });
    // } else {
    //   setAlertOpen(true);
    //   setAlertMsg(
    //     "Your Url is invalid. Please try again or contact with admin"
    //   );
    //   setAlertIcon("error");
    // }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  return (
    <Box>
      <Grid container>
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{
            // height: "90vh",
            width: "100%",
          }}
        >
          <Box
            display={"flex"}
            // justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            // height={"100%"}
            width={"100%"}
            margin={"auto"}
          >
            <Box mt={10}>
              <LimospayIcon />
            </Box>
            <Typography
              margin={"auto"}
              mt={2}
              color={"text.grayText"}
              fontWeight="bold"
              variant="h4"
              display={"flex"}
              width={"55%"}
              height={"55%"}
              alignItems={"center"}
            >
              Providing secure Payment Infrasture
            </Typography>

            <Typography
              margin={"auto"}
              mt={5}
              color={"text.grayText"}
              variant="subtitle"
              display={"flex"}
              width={{ xs: "70%", sm: "60%", md: "55%" }}
              height={"55%"}
              alignItems={"center"}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem
              iaculis lectus vitae interdum vestibulum amet urna blandit.
              Scelerisque iaculis auctor nibh justo in pretium. Praesent
            </Typography>
          </Box>
        </Grid>

        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
          <Box
            display={"flex"}
            justifyContent={"space-around"}
            alignItems={"center"}
            flexDirection={"column"}
            height={"100%"}
            width={{ xs: "90%", sm: "70%" }}
            margin={"auto"}
          >
            <Paper
              elevation={1}
              sx={{
                borderTop: `5px solid  ${theme.palette.primary.main}`,
                borderRadius: 1,

                marginTop: 6,
              }}
            >
              <Box>
                <Box className={classes.flexSetting} mt={4}>
                  <LimospayTextIcon />
                </Box>
                <Typography
                  color="#333333"
                  mt={3}
                  className={classes.flexSetting}
                >
                  Forgot Password
                </Typography>
                <Box width={"70%"} margin={"auto"}>
                  <Typography
                    variant="subtitle2"
                    className={classes.flexSetting}
                    textAlign={"center"}
                    m="2rem"
                  >
                    To reset your password, kindly enter the email you used to
                    create this account
                  </Typography>
                </Box>

                <Box>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={resetPasswordSchema}
                    onSubmit={submitHandler}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <Box
                          margin={"auto"}
                          width={"80%"}
                          mt={5}
                          fontSize={"15px"}
                        >
                          {/* <TextField
                            fullWidth
                            name="password"
                            type={showPassword ? "text" : "password"}
                            variant="standard"
                            label="Password"
                            value={values?.password}
                            error={
                              touched?.password && Boolean(errors?.password)
                            }
                            helperText={touched?.password && errors?.password}
                            onChange={handleChange("password")}
                            endadornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff sx={{ width: "19px" }} />
                                  ) : (
                                    <Visibility sx={{ width: "19px" }} />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          ></TextField> */}
                          <FormControl
                            sx={{ m: 1, width: "100%" }}
                            variant="standard"
                          >
                            <InputLabel htmlFor="standard-adornment-password">
                              Password
                            </InputLabel>
                            <Input
                              name="password"
                              type={showPassword ? "text" : "password"}
                              variant="standard"
                              fullWidth
                              label="Password"
                              value={values?.password}
                              error={
                                touched?.password && Boolean(errors?.password)
                              }
                              helperText={touched?.password && errors?.password}
                              onChange={handleChange("password")}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    // onMouseDown={handleMouseDownPassword}
                                  >
                                    {values.showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                          <FormControl
                            sx={{ m: 1, width: "100%" }}
                            variant="standard"
                          >
                            <InputLabel htmlFor="standard-adornment-password">
                              Password
                            </InputLabel>
                            <Input
                              fullWidth
                              name="confirm_password"
                              type={showPassword ? "text" : "password"}
                              variant="standard"
                              label="Confirm Password"
                              value={values?.confirm_password}
                              error={
                                touched?.password && Boolean(errors?.password)
                              }
                              helperText={touched?.password && errors?.password}
                              onChange={handleChange("confirm_password")}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    // onMouseDown={handleMouseDownPassword}
                                  >
                                    {values.showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                              sx={{
                                marginBottom: 1,
                                mb: { xs: 3, sm: 4, md: 5 },
                              }}
                            />
                          </FormControl>
                          <Button
                            variant="contained"
                            type="submit"
                            // onClick={() => submitHandler()}
                            fullWidth
                            sx={{
                              marginTop: 2,
                              height: theme.spacing(5),
                            }}
                          >
                            Set Password
                          </Button>
                        </Box>
                        <Box
                          className={classes.flexSetting}
                          mt={3}
                          mb={{ xs: 3, sm: 4, md: 5 }}
                        >
                          <Typography align="center">
                            Return to{" "}
                            <Link
                              sx={{
                                color: theme.palette.text,
                                cursor: "pointer",
                              }}
                              underline="none"
                              onClick={() => backToLogin()}
                            >
                              Login
                            </Link>{" "}
                          </Typography>
                        </Box>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Grid>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ResetPassword;
